import { ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="disclaimer-footer" className="border-t border-slate-800 bg-[#080C14]">
      <div className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
        <div className="flex items-center gap-2">
          <ShieldCheck className="h-4 w-4 text-[#FF5500]" />
          <span className="font-display text-sm font-semibold uppercase tracking-wide text-slate-200">
            WorkSafeAgent <span className="text-[#FF5500]">IR</span>
          </span>
        </div>
        <p data-testid="securities-disclaimer" className="mt-6 max-w-4xl text-xs leading-relaxed text-slate-500">
          This website is for informational purposes only and does not constitute an offer to sell
          or a solicitation of an offer to buy any securities of WorkSafeAgent LLC. Any investment
          would be made only through definitive documentation — a SAFE or simple convertible note —
          with terms to be determined with legal counsel. Figures shown reflect the company's
          status as of October 2026, including zero revenue and no paying customers to date.
        </p>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-widest text-slate-600">
          © 2026 WorkSafeAgent LLC · Abilene, TX · Confidential &amp; Proprietary
        </p>
      </div>
    </footer>
  );
}
